import React, { useCallback, useEffect, useState } from "react";
import ChildPic from "../../../../../assets/images/child-round.png";
import { Link } from "react-router-dom";
import useSubscription from "../../../../customHooks/subscriptionProvider";
import { AlertModal } from "../../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../../setup/alert/iconTypes";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import useLangTranslation from "../../../../customHooks/languageProvider";
import moment from "moment";
import useTimeSupervision from "./useTimeSupvervision";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import useFirebase from "../../../../../useFirebase";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import { setErrorInfo } from "../../../AxiosRtk/successMessage";
import { useHistory } from "react-router";
import SetRulesDisableSupervison from "../SetRulesDisableSupervison";
import useSetRules from "../useSetRules";
import DeleteChildInfo from "../../modals/DeleteChildInfo";
import Select from "react-select";
import { getMyIPAddress } from "../../../AxiosRtk/Miscellaneous";
import { deleteKidAccount } from "../../../AxiosRtk/AddNewChild/ADDNEWCHILDCURD";
import { setSelectedKidId } from "../../../AxiosRtk/DashBoard";
import useDurationOption from "../../../../customHooks/durationOption";
import KidImage from "../../../../shared/KidImage/KidImage";
// import { setRuleTimeSupervisionData } from '../../../AxiosRtk/SetRules';

const SetSchedule = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { checkSubsciption } = useSubscription();
  const { getLangTranslation } = useLangTranslation();

  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { daysAndWeekFunction } = useDurationOption();
  const daysAndWeekOptions = daysAndWeekFunction();

  const {
    getScheduleData,
    getDailyLimitSelectedDays,
    handleScheduleDataToggleChange,
    timeSupervisionApi,
    getDailyLimit,
    getTimeSuperVisionData,
    getSlotData,
    handleTimeRemove,
    postCollectionData,
    mergeTimeSlots,
  } = useTimeSupervision();

  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const [loader, setLoader] = useState(false);
  const [daySelect, setDaySelect] = useState("");
  const [deviceId, setDeviceId] = useState(null);
  const [kidDetails, setKidDetails] = useState(null);
  const [showDeletedModal, setShowDeletedModal] = useState(false);

  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const [scheduleData, setScheduleData] = useState([
    { key: "monday", value: [] },
    { key: "tuesday", value: [] },
    { key: "wednesday", value: [] },
    { key: "thursday", value: [] },
    { key: "friday", value: [] },
    { key: "saturday", value: [] },
    { key: "sunday", value: [] },
  ]);
  const [showModal, setShowModal] = useState(false);
  const [time, setTime] = useState({ stm: "00:00", etm: "00:00", diff: 0 });
  const [error, setError] = useState("");
  const [reason, setReason] = useState({ value: "", error: "" });
  const [deviceOptions, setDeviceOptions] = useState([]);

  const { getCollectionData } = useFirebase();
  const { handleTimeSupervision } = useSetRules();
  // console.log(time)
  function closeModal() {
    setShowModal(false);
  }

  const getPublicIp0 = useCallback(async () => {
    try {
      const { data: ipAddData } = await getMyIPAddress();
      return ipAddData?.ip;
    } catch (error) {
      console.log("Ip0", error);
    }
  }, []);

  async function handleContinue() {
    if (!reason?.value) {
      setReason({
        ...reason,
        error: "Please enter reason",
      });
      return;
    }

    setLoader(true);

    const ip = await getPublicIp0();

    const deleteProfilePayload = {
      kidId: selectedKidId,
      kidName: kidDetails?.childName,
      ipAddress: ip,
      reason: reason?.value,
    };

    deleteKidAccount(deleteProfilePayload)
      .then((res) => {
        closeModal();
        setShowDeletedModal(true);
      })
      .catch((err) => {
        setReason({
          ...reason,
          error: err?.response?.data?.message + ". Redirecting to dashboard.",
        });
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 2500);
        console.log(
          "child delete catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setLoader(false);
        dispatch(setSelectedKidId(kidList[0]?.ID));
      });
    // console.log(deleteProfilePayload)
  }

  // console.log("timeSupervisionData =>>", timeSupervisionData)
  // console.log("scheduleData ==>>", scheduleData)

  useEffect(() => {
    if (selectedDeviceData) {
      setDeviceId(selectedDeviceData?.ID?.ID);
    }
  }, [selectedDeviceData]);
  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);
  useEffect(() => {
    if (selectedDeviceData?.ID) {
      getDeviceStatusData(selectedDeviceData?.ID);
      getCollectionData(selectedDeviceData?.ID);
    } else {
      setDeviceStatus("");
      dispatch(setRuleDataSetUp(null));
    }
  }, [selectedDeviceData?.ID]);

  function handleInputChange(e) {
    const { name, value } = e.target;

    if (name === "stm") {
      let diff = 0;
      if (time?.etm) {
        diff = moment(time.etm, "hh:mm").diff(
          moment(value, "hh:mm"),
          "seconds"
        );
      }
      setTime({
        ...time,
        stm: value,
        diff,
      });
    } else if (name === "etm") {
      let diff = 0;
      if (time?.stm) {
        diff = moment(value, "hh:mm").diff(
          moment(time.stm, "hh:mm"),
          "seconds"
        );
      }
      setTime({
        ...time,
        etm: value,
        diff,
      });
    } else if (name === "day-select") {
      setDaySelect(value);
    }
  }

  function getSelectedDays() {
    const newTempObj = {};

    scheduleData.forEach((item) => {
      newTempObj[item?.key[0]?.toUpperCase() + item?.key?.substring(1)] =
        item?.isDaySelected;
    });

    return newTempObj;
  }

  function handleAddLimitBtn() {
    // console.log(deviceId)
    if (!checkSubsciption()) {
      return;
    }
    if (!selectedDeviceData?.ID) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "Device not selected",
          defaultTitle: "Device not selected",
        })
      );
      // AlertModal("Device not selected", alertIconType?.errorIcon, true);
      return;
    } else if (isEmpty(daySelect)) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "Day not selected",
          defaultTitle: "Day not selected",
        })
      );
      return;
    } else if (time.diff <= 0) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "The start time will be less than end time",
          defaultTitle: "TIME_SUPERVISION_BOTTOM_SHEET_START_TIME_WILLBE_LESS_THAN_END_TIME",
        })
      );
      return;
    }

    const payload = {
      kidId: selectedKidId,
      deviceId: selectedDeviceData?.ID,
      DailyLimit: getDailyLimit(setRulesData?.timesupervison?.dailyLimit),
      dailyLimitSelectedDays: getSelectedDays(),
      IsWarnKidByAlertEnabled:
        setRulesData?.timesupervison?.isWarnKidByAlertEnabled,
      IsDeviceTimeSupervisionEnabled:
        setRulesData?.timesupervison?.IsDeviceTimeSupervisionEnabled,
      IsBlockWebAndAppEnabled:
        setRulesData?.timesupervison?.isBlockWebAndAppEnabled,
      IsAllowAndMonitorParentsEnabled:
        setRulesData?.timesupervison?.isAllowAndMonitorParentsEnabled,
      Schedule: mergeTimeSlots([
        ...(setRulesData?.timesupervison?.schedule ?? []),
        ...getSlotData(time, daySelect),
      ]),
      dailyLimitSeekBarProgress: 0,
      AllowedApps: [],
      AllowedContacts: [],
    };
    // console.log(...getSlotData())
    // console.log(setRulesData)
    // console.log(setRulesData?.timesupervison?.schedule)

    const dailyLimitSelectedDays = {
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0,
    };
    const tempArr = [
      // ...(setRulesData?.timesupervison?.schedule ?? []),
      ...mergeTimeSlots([
        ...(setRulesData?.timesupervison?.schedule ?? []),
        ...getSlotData(time, daySelect),
      ]),
    ];

    tempArr?.forEach((item) => {
      dailyLimitSelectedDays[item?.day] = 1;
    });
    // console.log(setRulesData?.timesupervison?.schedule);
    const collectionPayload = {
      ...setRulesData?.timesupervison,
      schedule: [
        // ...(setRulesData?.timesupervison?.schedule ?? []),
        ...mergeTimeSlots([
          ...(setRulesData?.timesupervison?.schedule ?? []),
          ...getSlotData(time, daySelect),
        ]),
      ],
      dailyLimitSelectedDays,
    };
    // console.log("payload ==>>", payload);
    // console.log("collection payload ==>>", collectionPayload);

    postCollectionData(selectedDeviceData?.ID, { timesupervison: collectionPayload });
    getTimeSuperVisionData(selectedDeviceData?.ID);
    timeSupervisionApi(payload);
  }

  function handleClearAllBtn() {
    setDaySelect("");
    setTime({ stm: "00:00", etm: "00:00", diff: 0 });

    const collectionPayload = {
      ...setRulesData?.timesupervison,
      schedule: [],
      dailyLimitSelectedDays: {
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0,
        sunday: 0
      }
    };
    postCollectionData(selectedDeviceData?.ID, { timesupervison: collectionPayload });
    getTimeSuperVisionData(selectedDeviceData?.ID);

    const payload = {
      kidId: selectedKidId,
      deviceId: selectedDeviceData?.ID,
      dailyLimitSelectedDays: {
        Monday: 0,
        Tuesday: 0,
        Wednesday: 0,
        Thursday: 0,
        Friday: 0,
        Saturday: 0,
        Sunday: 0
      },
      schedule: [],
      dailyLimitSeekBarProgress: 0
    };

    timeSupervisionApi(payload);
  }

  useEffect(() => {
    if (kidList?.length > 0 && selectedKidId) {
      const kid = kidList.find((item) => item?.ID === selectedKidId);
      setKidDetails(kid);
    }
  }, [selectedKidId]);

  useEffect(() => {
    function getData() {
      const schFormattedData = getScheduleData(
        setRulesData?.timesupervison?.schedule
      );
      // console.log("schFormattedData ==>>", schFormattedData)
      const daySelecteData = getDailyLimitSelectedDays(
        setRulesData?.timesupervison?.dailyLimitSelectedDays ?? {},
        schFormattedData
      );
      setScheduleData(daySelecteData);
      // console.log("daySelecteData ==>>", daySelecteData);
    }

    if (setRulesData) {
      // console.log(setRulesData)
      getData();
    }
  }, [setRulesData]);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  // console.log(scheduleData)

  function getOpacity(dayStatus) {
    // console.log("dayStatus ==>>", dayStatus)
    if (parseInt(dayStatus) === 0) {
      return {
        opacity: "0.3"
      }
    }
    return {
      opacity: "none"
    }
  }

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    onClick={() => history.goBack()}
                    className="text-blue-900 fs-5 cursor-pointer"
                  >
                    <i
                      className={`${lang?.isRTL === 1
                        ? "icon-arrow-right"
                        : "icon-arrow-left"
                        }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "TIME_SUPERVISION_SET_A_SCHEDULE",
                      "Set a schedule"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imageUrl={kidDetails?.image} gender={kidDetails?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kidDetails?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find((item) => item?.value == selectedDeviceData?.ID) || ""
                  }
                  onChange={(val) => {
                    setDeviceId(val.value);
                  }}
                  isSearchable={false}
                />
              </div>
            </div>
            {selectedDeviceData?.ID && (
              <>
                <SetRulesDisableSupervison
                  enableSupervision={setRulesData?.enableSupervision}
                  handleTimeSupervision={handleTimeSupervision}
                  deviceSelected={selectedDeviceData?.ID}
                />
                <span className="icon-wrap pt-cursor">
                  {/* <i className="icon-setting"></i> */}
                  <div className="dropdown">
                    <i
                      className="icon-setting  pt-cursor"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    />
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                        onClick={() =>
                          history.push("/set-rules/manage-notifications")
                        }
                      >
                        {getLangTranslation(
                          "MANAGE_NOTIFICATIONS",
                          "Manage notifications"
                        )}  <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                        onClick={() => history.push("/set-rules/copy-settings")}
                      >
                        {getLangTranslation("COPY_SETTINGS", "Copy settings")} <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                        onClick={() =>
                          history.push("/set-rules/default-settings")
                        }
                      >
                        {getLangTranslation(
                          "SETRULE_LOAD_DEFAULT_SETTINGS",
                          "Load default settings"
                        )} <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1 text-danger"
                        onClick={() => setShowModal(true)}
                      >
                        {getLangTranslation("SET_RULES_DELETE_CHILD_PROFILE", "Delete child's profile")?.replace('child', kidDetails?.childName)}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                    </ul>
                  </div>
                </span>
              </>
            )}
            <DeleteChildInfo
              showModal={showModal}
              closeModal={closeModal}
              handleContinue={handleContinue}
              loader={loader}
              reason={reason}
              setReason={setReason}
              getLangTranslation={getLangTranslation}
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center gap-6 mb-6 flex-wrap">
            <h5 className="mb-0 text-blue-900">
              {getLangTranslation("SET_ALLOWED_TIME", "Set allowed times")}
            </h5>
            <div className="d-flex align-items-center gap-6 flex-wrap justify-content-end flex-lg-nowrap flex-fill">
              <div className="d-flex align-items-center gap-3 content-400 w-100 flex-wrap flex-md-nowrap">
                <div className="d-flex align-items-center content-200 w-100 gap-2">
                  <span className="text-small text-dark text-nowrap">
                    {getLangTranslation(
                      "PARENT_CHILD_DETAIL_CURRENT_LOCATION_FROM",
                      "From"
                    )}
                  </span>
                  <input
                    type="time"
                    className={`form-control text-blue-900 ${time.stm ? "" : "time-placeholder"
                      }`}
                    placeholder="HH"
                    name="stm"
                    value={time.stm || ""}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="d-flex align-items-center content-200 w-100 gap-2">
                  <span className="text-small text-dark text-nowrap">
                    {getLangTranslation("TO", "To")}
                  </span>
                  <input
                    type="time"
                    className={`form-control text-blue-900 ${time.etm ? "" : "time-placeholder"
                      }`}
                    placeholder="End Time"
                    name="etm"
                    value={time.etm || ""}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              {error && (
                <div className="mx-8">
                  <span className="text-danger" style={{ fontSize: "12px" }}>
                    {getLangTranslation(error)}
                    {/* {error} */}
                  </span>
                </div>
              )}
              <Select
                className="custom-select col-md-3"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  setDaySelect(val.value);
                }}
                options={daysAndWeekOptions}
                value={
                  daysAndWeekOptions?.find(
                    (item) => item?.value == daySelect
                  ) || ""
                }
              />

              <div className="d-flex align-items-center gap-3">
                <button
                  className="btn btn-primary g-col-6"
                  type="button"
                  onClick={handleAddLimitBtn}
                // disabled={apiHit}
                >
                  <span className="btn-upper-case text-nowrap">
                    {getLangTranslation("ADD_LIMIT", "Add Limit")}
                  </span>
                </button>
                <button
                  className="btn btn-outline-primary g-col-6"
                  type="button"
                  onClick={handleClearAllBtn}
                >
                  <span className="btn-upper-case text-nowrap">
                    {getLangTranslation(
                      "PARENT_NOTIFICATION_FILTER_CLEAR_ALL",
                      "Clear All"
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
          <ul className="bordered-list bordered-list-multiple">
            {scheduleData?.map((day, index) => {
              return (
                <li className="text-center" key={index}>
                  <label className="pt-cursor">
                    <span className="text-blue-800 text-small text-uppercase">
                      {day?.key}
                    </span>
                    <span className="form-check  form-switch mx-auto mt-2">
                      <input
                        className="form-check-input c-pointer"
                        type="checkbox"
                        role="switch"
                        name={day?.key?.toUpperCase()}
                        checked={day?.value?.length && !!day?.isDaySelected}
                        onChange={(e) => {
                          if (day?.value?.length) {
                            handleScheduleDataToggleChange(
                              e,
                              scheduleData,
                              setScheduleData,
                              selectedDeviceData?.ID,
                              time,
                              daySelect
                            )
                          } else {
                            return;
                          }
                        }}
                      />
                    </span>
                  </label>
                  <span className="bordered-list-text ">
                    {day?.value?.map((time, timeIndex) => {
                      return (
                        <div
                          className={`bordered-list-text-inner ${!day?.isDaySelected ? 'opacity-3' : 'none'}`}
                          key={timeIndex}
                        >
                          <span className="bg-blue-50 text-blue-900 text-small p-1 border rounded-1">
                            {`${time?.startTime || '--'} - ${time?.endTime || '--'}`}
                          </span>
                          <i
                            className="
                                                                    icon-remove 
                                                                    fs-6 
                                                                    text-blue-600 
                                                                    pt-cursor
                                                                "
                            onClick={() => {
                              if (day?.isDaySelected) {
                                handleTimeRemove(
                                  day?.key,
                                  time?.startTime,
                                  time?.endTime,
                                  scheduleData,
                                  setScheduleData,
                                  selectedDeviceData?.ID
                                )
                              }
                            }}
                          />
                        </div>
                      );
                    })}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SetSchedule;
